(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.getElementById('announcement-bar');
    if (!bar) return;

    var closeBtn = bar.querySelector('.announcement-bar__close');
    if (!closeBtn) return;

    closeBtn.addEventListener('click', function () {
      bar.hidden = true;
      try {
        sessionStorage.setItem('hw-announcement-closed', bar.dataset.announcementKey);
      } catch (e) {}
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["archive"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var items = document.querySelectorAll('.archive-item');
    var overlay = document.getElementById('archive-overlay');
    if (!overlay || !items.length) return;

    window.HW = window.HW || {};
    window.HW.closeArchiveOverlay = function () {
      if (overlay.classList.contains('is-open')) close();
    };

    var dataEl = document.getElementById('archive-quick-view-data');
    var products = [];
    if (dataEl) {
      try {
        products = JSON.parse(dataEl.textContent);
      } catch (e) {
        products = [];
      }
    }
    if (!products.length) return;

    var backdrop = document.getElementById('archive-overlay-backdrop');
    var card = document.getElementById('archive-overlay-card');
    var scrollEl = document.getElementById('archive-overlay-scroll');
    var closeBtn = document.getElementById('archive-overlay-close');
    var galleryTrack = document.getElementById('archive-overlay-gallery');
    var dotsEl = document.getElementById('archive-overlay-dots');
    var controlsEl = document.getElementById('archive-overlay-gallery-controls');
    var prevBtn = document.getElementById('archive-overlay-prev');
    var nextBtn = document.getElementById('archive-overlay-next');
    var titleEl = document.getElementById('archive-overlay-title');
    var descEl = document.getElementById('archive-overlay-description');
    var linkEl = document.getElementById('archive-overlay-link');

    var images = [];
    var activeItem = null;

    function currentSlideIndex() {
      if (!galleryTrack || !galleryTrack.clientWidth) return 0;
      return Math.round(galleryTrack.scrollLeft / galleryTrack.clientWidth);
    }

    function goToSlide(index) {
      var slides = galleryTrack.querySelectorAll('img');
      if (!slides[index]) return;
      galleryTrack.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    }

    function updateGalleryUI() {
      var index = currentSlideIndex();
      Array.from(dotsEl.querySelectorAll('.archive-overlay__dot')).forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
      });
      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= images.length - 1;
    }

    function buildDots() {
      dotsEl.innerHTML = '';
      images.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.className = 'archive-overlay__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Image ' + (i + 1));
        dot.addEventListener('click', function () {
          goToSlide(i);
        });
        dotsEl.appendChild(dot);
      });
      controlsEl.style.display = images.length > 1 ? '' : 'none';
    }

    function populate(index) {
      var data = products[index];
      if (!data) return;

      if (scrollEl) scrollEl.scrollTop = 0;

      images = data.images && data.images.length ? data.images : [];

      galleryTrack.innerHTML = '';
      galleryTrack.scrollLeft = 0;
      images.forEach(function (src) {
        var img = document.createElement('img');
        img.src = src;
        img.alt = data.title || '';
        galleryTrack.appendChild(img);
      });

      buildDots();
      updateGalleryUI();
      titleEl.textContent = data.title || '';
      descEl.innerHTML = data.description || '';
      linkEl.href = data.url || '#';
    }

    function animateOpen(fromRect) {
      var cardRect = card.getBoundingClientRect();
      var scaleX = fromRect.width / cardRect.width;
      var scaleY = fromRect.height / cardRect.height;
      var translateX = fromRect.left + fromRect.width / 2 - (cardRect.left + cardRect.width / 2);
      var translateY = fromRect.top + fromRect.height / 2 - (cardRect.top + cardRect.height / 2);

      card.style.transition = 'none';
      card.style.transform =
        'translate(-50%, -50%) translate(' +
        translateX +
        'px, ' +
        translateY +
        'px) scale(' +
        scaleX +
        ', ' +
        scaleY +
        ')';
      card.style.opacity = '0';

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          card.style.transition = 'transform 0.5s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.3s ease';
          card.style.transform = 'translate(-50%, -50%)';
          card.style.opacity = '1';
        });
      });
    }

    function open(item) {
      var index = parseInt(item.dataset.index, 10);
      if (isNaN(index)) return;

      if (window.HW && window.HW.closeQuickView) window.HW.closeQuickView();
      if (window.HW && window.HW.closeCartDrawer) window.HW.closeCartDrawer();

      activeItem = item;
      populate(index);

      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      var thumb = item.querySelector('.archive-item__image');
      var fromRect = (thumb || item).getBoundingClientRect();
      animateOpen(fromRect);
    }

    function close() {
      if (activeItem) {
        var thumb = activeItem.querySelector('.archive-item__image');
        var toRect = (thumb || activeItem).getBoundingClientRect();
        var cardRect = card.getBoundingClientRect();
        var scaleX = toRect.width / cardRect.width;
        var scaleY = toRect.height / cardRect.height;
        var translateX = toRect.left + toRect.width / 2 - (cardRect.left + cardRect.width / 2);
        var translateY = toRect.top + toRect.height / 2 - (cardRect.top + cardRect.height / 2);

        card.style.transition = 'transform 0.4s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.3s ease';
        card.style.transform =
          'translate(-50%, -50%) translate(' +
          translateX +
          'px, ' +
          translateY +
          'px) scale(' +
          scaleX +
          ', ' +
          scaleY +
          ')';
        card.style.opacity = '0';
      }

      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';

      setTimeout(function () {
        card.style.transition = 'none';
        card.style.transform = 'translate(-50%, -50%)';
        card.style.opacity = '1';
        activeItem = null;
      }, 450);
    }

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        open(item);
      });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          open(item);
        }
      });
    });

    closeBtn.addEventListener('click', close);
    backdrop.addEventListener('click', close);
    prevBtn.addEventListener('click', function () {
      goToSlide(currentSlideIndex() - 1);
    });
    nextBtn.addEventListener('click', function () {
      goToSlide(currentSlideIndex() + 1);
    });
    galleryTrack.addEventListener('scroll', updateGalleryUI, { passive: true });

    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') goToSlide(currentSlideIndex() - 1);
      if (e.key === 'ArrowRight') goToSlide(currentSlideIndex() + 1);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line    = parseInt(btn.dataset.line, 10);
        var display = btn.closest('.cart-item__qty').querySelector('.qty-display');
        var current = parseInt(display.textContent, 10);
        var next    = Math.max(0, current + parseInt(btn.dataset.delta, 10));

        btn.disabled = true;

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: next })
        }).then(function () {
          window.location.reload();
        }).catch(function () {
          btn.disabled = false;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    function fitWordmark() {
      var el = document.querySelector('.site-footer__display-wordmark');
      if (!el) return;
      el.style.fontSize = '100px';
      var range = document.createRange();
      range.selectNodeContents(el);
      var textWidth = range.getBoundingClientRect().width;
      if (textWidth > 0) {
        var padding = parseFloat(getComputedStyle(el).paddingLeft) + parseFloat(getComputedStyle(el).paddingRight) + 0;
        el.style.fontSize = Math.floor((100 * (window.innerWidth - padding)) / textWidth) + 'px';
      }
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(fitWordmark);
    } else {
      fitWordmark();
    }

    window.addEventListener('resize', fitWordmark, { passive: true });

    /* ── Wood-grain pages only: solidify once scrolled to the bottom ── */
    var woodgrainFooter = document.querySelector('.site-footer--woodgrain');
    if (woodgrainFooter) {
      var scrollTimer;
      function checkBottom() {
        var atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 20;
        woodgrainFooter.classList.toggle('is-solid', atBottom);
      }
      window.addEventListener(
        'scroll',
        function () {
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(checkBottom, 80);
        },
        { passive: true }
      );
      window.addEventListener('resize', checkBottom, { passive: true });
      checkBottom();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('.site-header');
    var shopTrigger = document.querySelector('.site-header__shop-trigger');
    var menuBtn = document.querySelector('.site-header__menu-btn');
    var nav = document.querySelector('.site-nav');
    var overlay = document.querySelector('.site-nav__overlay');
    var collections = document.querySelector('.site-nav__collections');
    var categoriesToggle = document.querySelector('.site-nav__categories-toggle');
    var categoriesPanel = document.getElementById('site-nav-categories');
    var hoverCapable = window.matchMedia('(hover: hover)').matches;

    if (!header) return;

    /* ── Reveal on load ─────────────────────────────────────────────
       Homepage only — other pages are already visible via .no-hero.
       Fires just after first paint so the fade/slide-in still plays
       instead of jumping straight to the revealed state. ─────────── */
    if (!header.classList.contains('no-hero')) {
      var revealEls = Array.prototype.slice.call(
        header.querySelectorAll(
          '.site-header__wordmark, .site-header__nav-link, .site-header__menu-btn, .site-header__actions'
        )
      );
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          revealEls.forEach(function (el) {
            el.classList.add('is-revealed');
          });
        });
      });
    }

    /* ── Scroll state ───────────────────────────────────────────── */
    var scrolledTimer;
    window.addEventListener(
      'scroll',
      function () {
        clearTimeout(scrolledTimer);
        scrolledTimer = setTimeout(function () {
          header.classList.toggle('is-scrolled', window.scrollY > 10);
        }, 15);
      },
      { passive: true }
    );

    if (!nav) return;

    /* ── Touch detection ────────────────────────────────────────── */
    var isTouch = false;
    document.addEventListener(
      'touchstart',
      function () {
        isTouch = true;
      },
      { once: true, passive: true }
    );

    /* ── Open / close ───────────────────────────────────────────── */
    var closeTimer;

    function openNav() {
      clearTimeout(closeTimer);
      nav.classList.add('is-open');
      nav.setAttribute('aria-hidden', 'false');
      header.classList.add('nav-is-open');
      if (overlay) overlay.classList.add('is-visible');
      if (menuBtn) menuBtn.setAttribute('aria-expanded', 'true');
      if (shopTrigger) shopTrigger.setAttribute('aria-expanded', 'true');
    }

    function scheduleClose() {
      closeTimer = setTimeout(closeNav, 250);
    }

    function closeNav() {
      nav.classList.remove('is-open');
      nav.setAttribute('aria-hidden', 'true');
      header.classList.remove('nav-is-open');
      if (overlay) overlay.classList.remove('is-visible');
      if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
      if (shopTrigger) shopTrigger.setAttribute('aria-expanded', 'false');
      closeCategories();
    }

    /* Desktop: hover Shop nav link to open */
    if (shopTrigger) {
      shopTrigger.addEventListener('mouseenter', function () {
        if (!isTouch) openNav();
      });
      shopTrigger.addEventListener('mouseleave', function () {
        if (!isTouch) scheduleClose();
      });
    }

    /* Keep open while in panel */
    nav.addEventListener('mouseenter', function () {
      if (!isTouch) clearTimeout(closeTimer);
    });
    nav.addEventListener('mouseleave', function () {
      if (!isTouch) scheduleClose();
    });

    /* Mobile: tap Menu button */
    if (menuBtn) {
      menuBtn.addEventListener('click', function () {
        nav.classList.contains('is-open') ? closeNav() : openNav();
      });
    }

    /* Overlay tap/click closes */
    if (overlay) overlay.addEventListener('click', closeNav);

    /* Escape closes */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeNav();
    });

    /* ── Categories: accordion (mobile) / flyout column (desktop) ── */
    var categoriesCloseTimer;

    function openCategories() {
      clearTimeout(categoriesCloseTimer);
      if (categoriesPanel) categoriesPanel.classList.add('is-expanded');
      if (categoriesToggle) categoriesToggle.setAttribute('aria-expanded', 'true');
      nav.classList.add('is-categories-open');
      if (collections) collections.classList.add('is-categories-open');
    }

    function closeCategories() {
      if (categoriesPanel) categoriesPanel.classList.remove('is-expanded');
      if (categoriesToggle) categoriesToggle.setAttribute('aria-expanded', 'false');
      nav.classList.remove('is-categories-open');
      if (collections) collections.classList.remove('is-categories-open');
    }

    if (categoriesToggle && categoriesPanel) {
      if (hoverCapable) {
        /* Desktop: hover to expand the panel rightward */
        categoriesToggle.addEventListener('mouseenter', openCategories);
        categoriesPanel.addEventListener('mouseenter', function () {
          clearTimeout(categoriesCloseTimer);
        });
        categoriesToggle.addEventListener('mouseleave', function () {
          categoriesCloseTimer = setTimeout(closeCategories, 250);
        });
        categoriesPanel.addEventListener('mouseleave', function () {
          categoriesCloseTimer = setTimeout(closeCategories, 250);
        });
      } else {
        /* Mobile: tap to replace the other items with the category list */
        categoriesToggle.addEventListener('click', function () {
          if (categoriesPanel.classList.contains('is-expanded')) {
            closeCategories();
          } else {
            openCategories();
          }
        });
      }
    }
  })();

  /* ── Cart drawer ─────────────────────────────────────────────── */
  (function () {
    var trigger = document.getElementById('cart-drawer-trigger');
    var drawer = document.getElementById('cart-drawer');
    if (!trigger || !drawer) return;

    window.HW = window.HW || {};
    window.HW.closeCartDrawer = function () {
      if (drawer.classList.contains('is-open')) close();
    };
    window.HW.openCartDrawer = function () {
      open();
    };

    var backdrop = document.getElementById('cart-drawer-backdrop');
    var closeBtn = document.getElementById('cart-drawer-close');
    var itemsEl = document.getElementById('cart-drawer-items');
    var emptyEl = document.getElementById('cart-drawer-empty');
    var footerEl = document.getElementById('cart-drawer-footer');
    var subtotalEl = document.getElementById('cart-drawer-subtotal');
    var cartCountEl = document.getElementById('cart-count');

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
      var parts = amount.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return '$' + parts.join('.');
    }

    function updateCartCount(cart) {
      if (cartCountEl) cartCountEl.textContent = cart.item_count;
    }

    function changeLine(key, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity }),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          render(cart);
          updateCartCount(cart);
        });
    }

    function renderItems(cart) {
      itemsEl.innerHTML = '';

      cart.items.forEach(function (item) {
        var row = document.createElement('div');
        row.className = 'cart-drawer__item';

        var img = document.createElement('img');
        img.className = 'cart-drawer__item-image';
        img.src = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
        img.alt = item.title;
        row.appendChild(img);

        var info = document.createElement('div');
        info.className = 'cart-drawer__item-info';

        var title = document.createElement('a');
        title.className = 'cart-drawer__item-title';
        title.href = item.url;
        title.textContent = item.product_title;
        info.appendChild(title);

        if (item.variant_title) {
          var variant = document.createElement('p');
          variant.className = 'cart-drawer__item-variant';
          variant.textContent = item.variant_title;
          info.appendChild(variant);
        }

        var price = document.createElement('p');
        price.className = 'cart-drawer__item-price';
        price.textContent = formatMoney(item.final_line_price);
        info.appendChild(price);

        var controls = document.createElement('div');
        controls.className = 'cart-drawer__item-controls';

        var qty = document.createElement('div');
        qty.className = 'cart-drawer__qty';

        var minusBtn = document.createElement('button');
        minusBtn.type = 'button';
        minusBtn.className = 'cart-drawer__qty-btn';
        minusBtn.textContent = '−';
        minusBtn.addEventListener('click', function () {
          changeLine(item.key, item.quantity - 1);
        });

        var qtyValue = document.createElement('span');
        qtyValue.className = 'cart-drawer__qty-value';
        qtyValue.textContent = item.quantity;

        var plusBtn = document.createElement('button');
        plusBtn.type = 'button';
        plusBtn.className = 'cart-drawer__qty-btn';
        plusBtn.textContent = '+';
        plusBtn.addEventListener('click', function () {
          changeLine(item.key, item.quantity + 1);
        });

        qty.appendChild(minusBtn);
        qty.appendChild(qtyValue);
        qty.appendChild(plusBtn);

        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'cart-drawer__item-remove';
        removeBtn.textContent = 'Remove';
        removeBtn.addEventListener('click', function () {
          changeLine(item.key, 0);
        });

        controls.appendChild(qty);
        controls.appendChild(removeBtn);
        info.appendChild(controls);

        row.appendChild(info);
        itemsEl.appendChild(row);
      });
    }

    function render(cart) {
      var hasItems = cart.items && cart.items.length > 0;
      emptyEl.hidden = hasItems;
      itemsEl.hidden = !hasItems;
      footerEl.hidden = !hasItems;
      if (hasItems) {
        renderItems(cart);
        subtotalEl.textContent = formatMoney(cart.total_price);
      }
    }

    function fetchCart() {
      return fetch('/cart.js')
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          render(cart);
        });
    }

    function open() {
      if (window.HW && window.HW.closeQuickView) window.HW.closeQuickView();
      if (window.HW && window.HW.closeArchiveOverlay) window.HW.closeArchiveOverlay();

      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      fetchCart();
    }

    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    trigger.addEventListener('click', function (e) {
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      open();
    });

    closeBtn.addEventListener('click', close);
    backdrop.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'hw_newsletter_dismissed';
    var DELAY_MS = 8000;

    // ?newsletter in the URL forces the popup to show immediately, bypassing the dismissal check
    var forceShow = new URLSearchParams(location.search).has('newsletter');
    var delay = forceShow ? 0 : DELAY_MS;

    // Don't show if already dismissed within the last 30 days
    var dismissed = localStorage.getItem(STORAGE_KEY);
    if (!forceShow && dismissed && Date.now() - parseInt(dismissed) < 30 * 24 * 60 * 60 * 1000) return;

    var popup  = document.getElementById('newsletter-popup');
    var close  = document.getElementById('newsletter-popup-close');

    function dismiss() {
      popup.classList.remove('is-visible');
      localStorage.setItem(STORAGE_KEY, Date.now().toString());
    }

    setTimeout(function () {
      popup.classList.add('is-visible');
      popup.removeAttribute('aria-hidden');
    }, delay);

    close.addEventListener('click', dismiss);

    // Hide permanently after successful subscribe
    var form = document.getElementById('newsletter-popup-form');
    if (form) {
      form.addEventListener('submit', function () {
        setTimeout(dismiss, 3000);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var variantsEl = document.getElementById('product-variants-json');
    if (!variantsEl) return;

    var variants = JSON.parse(variantsEl.textContent);
    var variantInput = document.getElementById('product-variant-id');
    var priceEl = document.getElementById('product-price');
    var atcBtn = document.getElementById('product-atc');
    var errorEl = document.getElementById('product-error');
    var productForm = document.getElementById('product-form');
    var optionGroups = document.querySelectorAll('.product-option__values');
    var currentVariant = variants.find(function (v) {
      return v.id === parseInt(variantInput ? variantInput.value : 0, 10);
    }) || null;

    /* ── Gallery: swipeable track + dots + arrows ─────────────────── */
    var track = document.getElementById('product-gallery-track');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('.product-gallery__slide')) : [];
    var dots = Array.prototype.slice.call(document.querySelectorAll('.product-gallery__dot'));
    var prevBtn = document.querySelector('.product-gallery .slider-arrow--prev');
    var nextBtn = document.querySelector('.product-gallery .slider-arrow--next');

    function currentSlideIndex() {
      if (!track) return 0;
      return Math.round(track.scrollLeft / track.clientWidth);
    }

    function goToSlide(index) {
      if (!track || !slides[index]) return;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    }

    function updateGalleryUI() {
      var index = currentSlideIndex();
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= slides.length - 1;
    }

    if (track && slides.length) {
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          goToSlide(i);
        });
      });
      if (prevBtn)
        prevBtn.addEventListener('click', function () {
          goToSlide(currentSlideIndex() - 1);
        });
      if (nextBtn)
        nextBtn.addEventListener('click', function () {
          goToSlide(currentSlideIndex() + 1);
        });
      track.addEventListener('scroll', updateGalleryUI, { passive: true });
      updateGalleryUI();
    }

    function goToImageId(imageId) {
      var index = slides.findIndex(function (slide) {
        return slide.dataset.imageId === String(imageId);
      });
      if (index > -1) goToSlide(index);
    }

    /* ── Variant selection ──────────────────────────────────────── */
    if (!optionGroups.length) return;

    function getSelectedOptions() {
      var opts = [];
      optionGroups.forEach(function (group) {
        var checked = group.querySelector('.product-option__radio:checked');
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }

    function findVariant(opts) {
      return (
        variants.find(function (v) {
          return v.options.every(function (o, i) {
            return o === opts[i];
          });
        }) || null
      );
    }

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
      var parts = amount.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return '$' + parts.join('.');
    }

    function updateVariant() {
      var opts = getSelectedOptions();
      var variant = findVariant(opts);

      if (!variant) {
        currentVariant = null;
        if (atcBtn) {
          atcBtn.disabled = true;
          atcBtn.textContent = 'Select options';
        }
        if (errorEl) {
          errorEl.textContent = 'Please select an option before adding to cart.';
          errorEl.hidden = false;
        }
        return;
      }

      currentVariant = variant;
      if (variantInput) variantInput.value = variant.id;
      if (errorEl) errorEl.hidden = true;

      if (priceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML =
            '<span class="product-info__price--sale">' +
            formatMoney(variant.price) +
            '</span>' +
            '<s class="product-info__price--compare">' +
            formatMoney(variant.compare_at_price) +
            '</s>';
        } else {
          priceEl.textContent = formatMoney(variant.price);
        }
      }

      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        atcBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }

      if (variant.featured_image) {
        goToImageId(variant.featured_image.id);
      }
    }

    optionGroups.forEach(function (group) {
      group.addEventListener('change', updateVariant);
    });

    if (productForm) {
      productForm.addEventListener('submit', function (e) {
        if (!currentVariant) {
          e.preventDefault();
          if (errorEl) {
            errorEl.textContent = 'Please select an option before adding to cart.';
            errorEl.hidden = false;
          }
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["returns"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.getElementById('returns-contact-form');
    if (!form) return;

    form.addEventListener('submit', function () {
      var holdItems = document.getElementById('returns-hold-items').value;
      var postcode = document.getElementById('returns-postcode').value;
      var questions = document.getElementById('returns-questions').value;

      var lines = [
        'Item(s) to place on hold: ' + holdItems,
        'Postcode: ' + postcode
      ];
      if (questions) lines.push('', questions);

      document.getElementById('returns-body').value = lines.join('\n');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.reviews__stage');

    sections.forEach(function (stage) {
      var track = stage.querySelector('.reviews__track');
      if (!track) return;

      var section = stage.closest('.reviews');
      var cards = Array.prototype.slice.call(track.querySelectorAll('.reviews__card'));
      var dots = Array.prototype.slice.call(section.querySelectorAll('.reviews__dot'));
      var prevBtn = section.querySelector('.reviews__arrow--prev');
      var nextBtn = section.querySelector('.reviews__arrow--next');
      var count = cards.length;
      if (!count) return;

      var activeIndex = 0;

      /* ── Live, scroll-position-driven styling ─────────────────────
         Real native horizontal scroll drives this (like the product
         gallery) so it tracks the gesture 1:1 — no simulated stepping,
         no debounce. Each card's scale/opacity/tilt is a continuous
         function of its actual live distance from the track's centre,
         recomputed every scroll frame. ─────────────────────────────── */

      function update() {
        var trackRect = track.getBoundingClientRect();
        var centerX = trackRect.left + trackRect.width / 2;
        var closestIndex = 0;
        var closestAbs = Infinity;

        cards.forEach(function (card, i) {
          var cardRect = card.getBoundingClientRect();
          var cardCenter = cardRect.left + cardRect.width / 2;
          /* Normalise against offsetWidth (stable layout size), not
             cardRect.width — that reflects the live post-scale() render
             size, which would otherwise feed back on itself: a card
             shrunk by our own scale() reads as "further away" next
             frame, shrinking it again until it's permanently hidden. */
          var delta = (cardCenter - centerX) / card.offsetWidth;
          var abs = Math.abs(delta);

          if (abs < closestAbs) {
            closestAbs = abs;
            closestIndex = i;
          }

          var falloff = delta <= 0 ? 1.15 : 0.6;
          var scale = Math.max(0.62, 1 - abs * 0.32);
          var opacity = Math.max(0, 1 - abs * falloff);
          var rotate = Math.max(-12, Math.min(12, -delta * 16));

          card.style.transform = 'scale(' + scale + ') rotateY(' + rotate + 'deg)';
          card.style.opacity = String(opacity);
          card.style.zIndex = String(Math.round((1 - abs) * 100));
          card.style.pointerEvents = abs < 1.4 ? 'auto' : 'none';
        });

        if (closestIndex !== activeIndex) {
          activeIndex = closestIndex;
          dots.forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === activeIndex);
          });
        }
        if (prevBtn) prevBtn.disabled = activeIndex === 0;
        if (nextBtn) nextBtn.disabled = activeIndex === count - 1;
      }

      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          update();
        });
      }

      track.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });

      function scrollToIndex(index) {
        index = Math.max(0, Math.min(count - 1, index));
        cards[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }

      cards.forEach(function (card, i) {
        card.addEventListener('click', function () {
          if (i !== activeIndex) scrollToIndex(i);
        });
      });

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          scrollToIndex(i);
        });
      });

      if (prevBtn)
        prevBtn.addEventListener('click', function () {
          scrollToIndex(activeIndex - 1);
        });
      if (nextBtn)
        nextBtn.addEventListener('click', function () {
          scrollToIndex(activeIndex + 1);
        });

      update();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
